import styled from "styled-components";

export const HostedLookupTableContanier = styled.div`
  .hosted-table-info {
    color: #0079c0;
    cursor: pointer;
    font-size: 20px;
  }
`;

export const HostedTableFooterContanier = styled.div`
  &.ant-modal-footer {
    position: absolute;
    margin: 0 0 0 -24px;
    bottom: 0;
    width: 100%;
  }
`;
